"use strict";

import * as types from './../actions/actionTypes.js';
import makeQuery from "../helper/Query";

export default ( state, action ) => {

    switch ( action.type ) {

        case types.PATTERNS_RECEIVED:
            var newCache = cloneCache(state);
            var cacheItem = {};
            cacheItem.result = action.response.result.result;
            if(cacheItem.result === "SUCCESS"){
                cacheItem.totalHits = action.response.result.totalHits;
                cacheItem.items = action.response.result.patterns;
                cacheItem.fetched = action.fetchedAt;
            }
            var Query = makeQuery(action.query);
            newCache[Query.getHash()] = cacheItem;
            return newCache;

        case types.DESIGNERINFO_RECEIVED:
            var newCache = cloneCache(state);
            var cacheItem = {};
            cacheItem.result = action.response.result.result;
            if(cacheItem.result === "SUCCESS"){
                cacheItem.items = action.response.result.designer;
                cacheItem.fetched = action.fetchedAt;
            }
            var Query = makeQuery(action.query);
            newCache[Query.getHash()] = cacheItem;
            return newCache;

        case types.CATEGORIES_RECEIVED:
            var newCache = cloneCache(state);
            var cacheItem = {};
            cacheItem.result = action.response.result.result;
            if(cacheItem.result === "SUCCESS"){
                cacheItem.items = action.response.result.categories;
                cacheItem.fetched = action.fetchedAt;
            }
            var Query = makeQuery(action.query);
            newCache[Query.getHash()] = cacheItem;
            return newCache;

        case types.COLORS_RECEIVED:
            var newCache = cloneCache(state);
            var cacheItem = {};
            cacheItem.result = action.response;
            if(cacheItem.result){
                cacheItem.items = action.response;
                cacheItem.fetched = action.fetchedAt;
            }
            var Query = makeQuery(action.query);
            newCache[Query.getHash()] = cacheItem;
            return newCache;

        default:
            return state;
    }

};

const cloneCache = (cache) => Object.assign({}, cache);

export const getQueryCache = (state) => state.stolo.queryCache;

export const getCacheItem = function getCacheItemFromGlobalState (state, query) {
    var Query = makeQuery(query);
    const cache = getQueryCache(state);
    return cache[Query.getHash()];
};



// WEBPACK FOOTER //
// ./src/reducers/queryCache.js